export const PAYMENT_LINK_TARIFF_TYPES: readonly string[] = [
  'free',
  'month',
  'stream_one_time',
  'stream_custom_period',
  'stream_custom_days',
  'stream_custom_weeks',
  'hour',
  'minute',
  'group_per_lesson',
]

/** Русские названия типов тарифа (create-link + попап записи). */
export const CRM_LINK_TARIFF_TYPE_LABELS: Record<string, string> = {
  free: 'Бесплатный',
  month: 'Помесячная оплата',
  hour: 'Индивидуальный с оплатой по занятию',
  minute: 'Индивидуальный с поминутной оплатой',
  group_per_lesson: 'Групповой с оплатой по занятию',
  stream_one_time: 'Оплата одним платежом',
  stream_custom_period: 'По настраиваемым периодам',
  stream_custom_days: 'По настраиваемым дням',
  stream_custom_weeks: 'По настраиваемым неделям',
}

export const getCrmLinkTariffTypeLabel = (tariffType?: string | null) => {
  if (!tariffType) return null
  return CRM_LINK_TARIFF_TYPE_LABELS[tariffType] ?? tariffType
}

/**
 * Какие типы тарифов показывают блок в create-link.
 * Для ишки: «Блок доступен для типов тарифов: …».
 */
export const CREATE_LINK_BLOCK_TARIFF_TYPES = {
  courseFields: [...PAYMENT_LINK_TARIFF_TYPES],
  enrollDate: [
    'month',
    'stream_custom_period',
    'stream_custom_days',
    'stream_custom_weeks',
  ],
  groupSelect: [
    'free',
    'month',
    'stream_one_time',
    'stream_custom_period',
    'group_per_lesson',
  ],
  individualLesson: ['hour', 'minute'],
  groupPerLesson: ['group_per_lesson'],
  /** Итого first_price × value (hour / minute / group_per_lesson). */
  lessonPrice: ['hour', 'minute', 'group_per_lesson'],
  streamCustomPeriod: [
    'stream_custom_period',
    'stream_custom_days',
    'stream_custom_weeks',
  ],
  monthly: ['month'],
  lessonCount: ['hour', 'minute', 'group_per_lesson'],
  streamOneTimePeriod: ['stream_one_time'],
  monthlyDiscount: ['month'],
  additionalCourses: [...PAYMENT_LINK_TARIFF_TYPES],
  promo: [...PAYMENT_LINK_TARIFF_TYPES],
  customPrice: ['stream_one_time'],
} as const

export const isLessonPaymentTariff = (type?: string) =>
  ['hour', 'minute', 'group_per_lesson'].includes(type ?? '')

/** hour / minute — индивидуальные параметры занятия в create-link. */
export const isIndividualLessonLinkTariff = (type?: string | null) =>
  ['hour', 'minute'].includes(type ?? '')

export const isGroupPerLessonLinkTariff = (type?: string | null) =>
  type === 'group_per_lesson'

/** Расчёт price = first_price × value (+ доп. курсы) в create-link. */
export const isLessonPriceLinkTariff = (type?: string | null) =>
  isIndividualLessonLinkTariff(type) || isGroupPerLessonLinkTariff(type)

export const isStreamCustomPeriodTariff = (type?: string) =>
  ['stream_custom_period', 'stream_custom_days', 'stream_custom_weeks'].includes(
    type ?? '',
  )

/** Только месячные настраиваемые периоды (скидка на ссылке). */
export const isStreamCustomMonthsTariff = (type?: string) =>
  type === 'stream_custom_period'

/** Разовая оплата (одним платежом) — цена + опциональная группа. */
export const isStreamOneTimeTariff = (type?: string | null) =>
  type === 'stream_one_time'

/** Тарифы create-link, где можно опционально указать group_id. */
export const isCourseLinkGroupSelectableTariff = (type?: string | null) =>
  [
    'free',
    'month',
    'stream_one_time',
    'stream_custom_period',
    'group_per_lesson',
  ].includes(type ?? '')
